module.exports = __webpack_public_path__ + "fonts/Flaticon.69080881.woff";